import React from "react";
import { RefreshCw } from "lucide-react";

function WebhookLoading() {
  return (
    <div className="min-w-0">
      <div className="overflow-hidden rounded-[22px] border border-[#d8e7ed] bg-white p-5 shadow-[0_16px_44px_rgba(15,43,66,0.06)] dark:border-dark-border dark:bg-dark-card">
        <div className="rounded-[17px] border border-dashed border-[#c9dce4] bg-[#f8fbfc] p-10 dark:border-dark-border dark:bg-dark-surface">
          <div className="flex items-center justify-center gap-3">

            <RefreshCw
              size={15}
              className="animate-spin text-[#147db5] dark:text-dark-primary"
            />

            <div>
              <p className="text-[11px] font-bold text-[#344f61] dark:text-dark-text-primary">
                Loading webhook configuration
              </p>

              <p className="mt-1 text-[9px] text-[#8194a0] dark:text-dark-text-muted">
                Fetching your WhatsApp webhook details...
              </p>
            </div>

          </div>
      </div>
    </div>
    </div>
  );
}

export default WebhookLoading;
